export default "__VITE_ASSET__D3j$h4jE__"